import React from 'react';
import { ShortCutConfig, useShortCut } from './useShortCut';

// Component for convenience (use in legacy class based components, etc.)
export const ShortCut = React.memo<ShortCutConfig>((props: ShortCutConfig) => {
  const {
    keyCode,
    action = undefined,
    disabled = undefined,
    ctrl,
    alt,
    shift,
    meta,
    option,
    cmd,
    help,
    icon
  } = props;

  useShortCut({
    keyCode,
    ctrl,
    alt,
    shift,
    meta,
    option,
    cmd,
    action,
    disabled,
    help,
    icon
  });
  return null;
});
